import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=97a24df4&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a24df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97a24df4')) {
      api.createRecord('97a24df4', component.options)
    } else {
      api.reload('97a24df4', component.options)
    }
    module.hot.accept("./tax.vue?vue&type=template&id=97a24df4&scoped=true&", function () {
      api.rerender('97a24df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_item/tax.vue"
export default component.exports